<template>
  <Mine_index v-if="config.mine_version == '1.0'"></Mine_index>
  <Mine30 v-else-if="config.mine_version == '3.0'"></Mine30>
  <Mine_new v-else></Mine_new>
</template>

<script>
import Mine_index from './mine_old.vue';
import Mine30 from './mine30.vue';
import Mine_new from './mine_new.vue';
import { mapState } from 'vuex';
export default {
  components: {
    Mine_index,
    Mine_new,
    Mine30
  },
  computed: {
    ...mapState(['config'])
  },
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style scoped></style>
